import { SewUser } from '@sew/auth-service';
import { createStore } from '@stencil/store';
import { Labels } from '../types/labels.types';
import { DomainInfo } from '../types/os-domain.types';
import { Permission } from '../types/permission.types';
import { ProjectMetaData } from '../types/project-metadata.types';
import { User } from '../types/user.types';

interface HeaderState {
    domainInfo: DomainInfo;
    language: string;
    projectMetaData: ProjectMetaData;
    labels: Labels;
    user: SewUser | User | null;
    permissions: Permission[] | null;
    useOidc: boolean;
    navigation: any;
}

const store = createStore<HeaderState>({
    domainInfo: undefined,
    language: undefined,
    projectMetaData: null,
    labels: null,
    user: undefined,
    permissions: undefined,
    useOidc: undefined,
    navigation: undefined,
});

export default store;
